// extracted by css-extract-rspack-plugin
export default {"FormControl":"project-name-editor-module__FormControl__RDa8p","TextInput":"project-name-editor-module__TextInput__p93Sx"};